(function () {
  "use strict";

  var IS_B2B_CUSTOMER = window.HDT_IS_B2B === true;

  var refreshTimer = null;
  var waitAttempts = 0;
  var maxWaitAttempts = 120;

  function getBSS() {
    return window.BSS_B2B || null;
  }

  function notifyBSS(action, eventName) {
    var bss = getBSS();
    if (!bss || !bss.observer || !bss.observer.cartSubject) return false;
    bss.observer.cartSubject.notifyObserver(action, eventName);
    return true;
  }

  function getCartStorage() {
    var bss = getBSS();
    if (!bss || !bss.storage || !bss.storage.cartStorage) return null;
    return bss.storage.cartStorage.store || null;
  }

  function buildVariantKeyMap() {
    var store = getCartStorage();
    var cartMap = new Map();
    if (!store || typeof store.forEach !== "function") return cartMap;
    store.forEach(function (value) {
      if (!value || !value.variant_id || !value.key) return;
      var variantId = String(value.variant_id);
      if (!cartMap.has(variantId)) cartMap.set(variantId, []);
      cartMap.get(variantId).push(value.key);
    });
    return cartMap;
  }

  function setAttr(el, name, value) {
    if (!el || el.hasAttribute(name)) return;
    el.setAttribute(name, value == null ? "" : value);
  }

  // Aggiunge attributi BSS a hdt-price nel carrello.
  // NON tocca hdt-compare-at-price — il prezzo barrato viene dal Liquid
  // e non deve essere sovrascritto da BSS.
  function markLineItemPrices(root) {
    if (!IS_B2B_CUSTOMER) return;
    var scope = root || document;
    var cartMap = buildVariantKeyMap();

    scope.querySelectorAll(".hdt-line-item, .hdt-cart-item, .mu-cart-item").forEach(function (item) {
      var itemKey = item.getAttribute("data-cart-item-key");
      var variantId = item.getAttribute("data-variant-id");

      if (!itemKey && variantId && cartMap.has(String(variantId))) {
        itemKey = cartMap.get(String(variantId))[0];
      }
      if (!itemKey) return;

      // Solo hdt-price e hdt-unit-price — MAI hdt-compare-at-price
      // perché BSS la nasconderebbe e il prezzo barrato sparirebbe
      item.querySelectorAll("hdt-price, hdt-unit-price").forEach(function (priceEl) {
        setAttr(priceEl, "bss-b2b-cart-item-key", itemKey);
        var tag = (priceEl.tagName || "").toLowerCase();
        if (tag === "hdt-price") {
          if (!priceEl.hasAttribute("bss-b2b-final-line-price")) {
            setAttr(priceEl, "bss-b2b-item-final-price", "");
            setAttr(priceEl, "bss-b2b-variant-price", "");
          }
        } else if (tag === "hdt-unit-price") {
          setAttr(priceEl, "bss-b2b-cart-item-unit-price", "");
        }
      });

      // Totale riga
      item.querySelectorAll(".hdt-cart-item__total hdt-price, .hdt-page_cart__total-price hdt-price").forEach(function (el) {
        setAttr(el, "bss-b2b-cart-item-key", itemKey);
        setAttr(el, "bss-b2b-final-line-price", "");
      });
    });
  }

  function markCartTotals(root) {
    if (!IS_B2B_CUSTOMER) return;
    var scope = root || document;
    var selectors = [
      "[data-er-cart-total-price]",
      "[data-cart-subtotal]",
      ".hdt-mini-cart__value",
      ".hdt-page-cart__value"
    ];
    scope.querySelectorAll(selectors.join(",")).forEach(function (totalEl) {
      setAttr(totalEl, "bss-b2b-cart-total-price", "");
    });
  }

  function refreshCartPrices(root) {
    if (!IS_B2B_CUSTOMER) return;
    markLineItemPrices(root || document);
    markCartTotals(root || document);
    notifyBSS("CartMutate", "CartPriceMutate");
  }

  function scheduleRefresh(root, delay) {
    if (!IS_B2B_CUSTOMER) return;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshCartPrices(root || document);
    }, delay || 120);
  }

  function checkout() {
    return notifyBSS("CartCheckout", "ClickCheckout");
  }

  function waitForBSS() {
    if (!IS_B2B_CUSTOMER) return;
    waitAttempts += 1;
    if (getBSS()) {
      scheduleRefresh(document, 0);
      return;
    }
    if (waitAttempts < maxWaitAttempts) {
      window.setTimeout(waitForBSS, 500);
    }
  }

  // ── Quick View / Quick Add ──────────────────────────────────────
  var quickTimer = null;
  var atcTimer = null;

  function getB2BPriceFromModal(modal) {
    var hdtPrice = modal.querySelector("hdt-price[bss-b2b-variant-price] span[style]")
                || modal.querySelector("hdt-price[bss-b2b-product-price] span[style]");
    if (hdtPrice && hdtPrice.textContent.trim()) {
      return hdtPrice.textContent.trim();
    }
    return null;
  }

  function syncATCButton(modal) {
    if (!modal) return;
    var b2bPrice = getB2BPriceFromModal(modal);
    if (!b2bPrice) return;
    var qtyPrice = modal.querySelector("hdt-qty-price .hdt-money");
    if (qtyPrice) qtyPrice.textContent = b2bPrice;
  }

  function triggerBSSOnModal(modal) {
    if (!IS_B2B_CUSTOMER || !modal) return;
    var form = modal.querySelector("[bss-b2b-main-product-form]");
    if (!form || !form.parentNode) return;
    var parent = form.parentNode;
    var next = form.nextSibling;
    parent.removeChild(form);
    window.requestAnimationFrame(function () {
      if (next) {
        parent.insertBefore(form, next);
      } else {
        parent.appendChild(form);
      }
      notifyBSS("CartMutate", "CartPriceMutate");
      window.clearTimeout(atcTimer);
      atcTimer = window.setTimeout(function () {
        syncATCButton(modal);
        window.setTimeout(function () { syncATCButton(modal); }, 400);
      }, 350);
    });
  }

  function scheduleQuickTrigger(modal, delay) {
    if (!IS_B2B_CUSTOMER) return;
    window.clearTimeout(quickTimer);
    quickTimer = window.setTimeout(function () {
      triggerBSSOnModal(modal);
    }, delay || 150);
  }

  function bindEvents() {
    if (IS_B2B_CUSTOMER) {
      ["cart:change", "cart:drawer:change", "cart:drawer:render", "variant:add", "shopify:section:load"].forEach(function (eventName) {
        document.addEventListener(eventName, function (event) {
          scheduleRefresh(event.target || document, 250);
        });
      });

      document.addEventListener("visibilitychange", function () {
        if (!document.hidden) scheduleRefresh(document, 300);
      });

      var _mutationBusy = false;
      var cartObserver = new MutationObserver(function (mutationList) {
        if (_mutationBusy) return;
        var hasStructural = mutationList.some(function (mutation) {
          if (mutation.type !== "childList") return false;
          if (!mutation.addedNodes.length && !mutation.removedNodes.length) return false;
          if (!mutation.target || !mutation.target.closest) return false;
          var inCart = !!mutation.target.closest("#CartDrawer, #hdt-page-cart, .hdt-mini-cart__items, .hdt-cart-items");
          if (!inCart) return false;
          var hasElementNodes = false;
          mutation.addedNodes.forEach(function (n) { if (n.nodeType === 1) hasElementNodes = true; });
          mutation.removedNodes.forEach(function (n) { if (n.nodeType === 1) hasElementNodes = true; });
          return hasElementNodes;
        });
        if (hasStructural) {
          _mutationBusy = true;
          scheduleRefresh(document, 350);
          window.setTimeout(function () { _mutationBusy = false; }, 600);
        }
      });
      if (document.body) {
        cartObserver.observe(document.body, { childList: true, subtree: true });
      }

      // Quick add / quick view
      document.addEventListener("dialog:afterOpen", function (event) {
        var modal = event.target;
        if (!modal || !modal.id) return;
        if (modal.id === "hdt-quick-add-modal" || modal.id === "hdt-quick-view-modal") {
          scheduleQuickTrigger(modal, 150);
        }
      });

      document.addEventListener("variant:change", function (event) {
        var qv = document.getElementById("hdt-quick-view-modal");
        var qa = document.getElementById("hdt-quick-add-modal");
        var modal = (qv && qv.hasAttribute("open")) ? qv
                  : (qa && qa.hasAttribute("open")) ? qa : null;
        if (!modal || !modal.contains(event.target)) return;
        scheduleQuickTrigger(modal, 100);
      });
    }

    document.addEventListener("click", function (event) {
      var btn = event.target.closest('[data-bss-cart-checkout="true"]');
      if (!btn) return;
      if (checkout()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    }, true);
  }

  window.BSS_B2B_THEME = {
    refreshCartPrices: refreshCartPrices,
    checkout: checkout,
    isB2B: IS_B2B_CUSTOMER
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bindEvents();
      if (IS_B2B_CUSTOMER) {
        waitForBSS();
        scheduleRefresh(document, 0);
      }
    });
  } else {
    bindEvents();
    if (IS_B2B_CUSTOMER) {
      waitForBSS();
      scheduleRefresh(document, 0);
    }
  }
})();